import { apiSlice } from "../../app/api/apiSlice";

export const deletePendingApplicationApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    deletePendingApplication: builder.mutation({
      query: (payload) => {
        const loanHistoryId = payload?.loan_history_id ?? payload?.id;
        if (!loanHistoryId) {
          throw new Error("loan_history_id is required for deletePendingApplication");
        }
        return {
          url: `/api/v1/loan/delete_pending_applications/${loanHistoryId}/`,
          method: "DELETE",
        };
      },
    }),
  }),
});

export const { useDeletePendingApplicationMutation } = deletePendingApplicationApiSlice;
